<template>
  <div
    v-show="$parent.chat"
    class="position-relative chat-holder">
    <div class="mb-2 d-none d-md-flex">
      <span class="mr-auto">
        <chevron-left-icon
          :size="24"
          class="align-middle"
          @click="toggleChat()"/>
      </span>
      <span class="m-auto fs14"><b class="align-middle">Meeting Chat</b></span>
      <span
        :size="24"
        class="ml-auto"/>
    </div>
    <div class="mobileHeader shadow">
      <span class="m-auto fs14"><b>Meeting Chat</b></span>
      <close-icon @click="toggleChat()"/>
    </div>
    <div
      class="chatContainer">
      <perfect-scrollbar ref="chatArea">
        <div
          v-for="(chat, index) in chats"
          :class="{other: !chat.self, 'mt-auto': index === 0 }"
          :key="index"
          class="message">
          <div class="d-flex flex-column justify-content-end message-aligner">
            <div>
              <span
                v-if="!chat.self
                  && (chats[index - 1] && chats[index - 1].srcIM.userID !== chat.srcIM.userID
                  || typeof chats[index - 1] == 'undefined'
                )"
                class="who d-block fs12 mt-2">{{ chat.srcIM.firstName }} {{ chat.srcIM.lastName }}</span>
            </div>
            <div class="bubble-holder d-flex align-items-center flex-row-reverse">
              <div
                class="bubble rounded fs14 position-relative"
                v-html="chat.IMMsg"/>
              <span
                :class="{'visible-md-down': (chats[index + 1] && chats[index + 1].srcIM.userID !== chat.srcIM.userID || typeof chats[index + 1 ] == 'undefined')}"
                class="time fs12">{{ chat.time }}</span>
            </div>
          </div>
        </div>
      </perfect-scrollbar>
    </div>
    <div class="form-label-group inputHolder">
      <b-input
        id="chat-type"
        :disabled="isDisabledChat"
        v-model="chatMessage"
        :placeholder="isDisabledChat ? $t('MEETING.CHAT_DISABLED') : $t('MEETING.CHAT_PLACEHOLDER')"
        onfocus="this.original = this.placeholder; this.placeholder = ''"
        onblur="this.placeholder = this.original"
        class="chat-input"
        type="text"
        autocomplete="off"
        @keydown.native="pressedEnter"/>
      <label
        class="chatLabel"
        for="chat-type">{{ isDisabledChat ? $t('MEETING.CHAT_DISABLED') : $t('MEETING.CHAT_PLACEHOLDER') }}</label>
    </div>
  </div>
</template>
<script>
import {ref, computed} from "@vue/composition-api"
import ChevronLeftIcon from "icons/ChevronLeft"
import PlusBoxIcon from "icons/PlusBox"
import CloseIcon from "icons/Close"
import {PerfectScrollbar} from 'vue2-perfect-scrollbar'

export default {
  name: 'ChatSide',
  components: {
    ChevronLeftIcon,
    PlusBoxIcon,
    CloseIcon,
    PerfectScrollbar
  },
  setup(props, context) {
    const chatMessage = ref('')
    const selectedChat = ref(null)
    const chats = ref([])
    const publicChat = ref({value: "public", name: "Everyone", newMsg: 0})
    const dateLastUpdate = ref("")

    function beep() {
      if (context.parent.$parent.getItem('beepMessage') == undefined || context.parent.$parent.getItem('beepMessage')) {
        let snd = new Audio("data:audio/wav;base64,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")
        snd.play()
      }
    }

    function toggleChat() {
      context.parent.$parent.expanded = !context.parent.$parent.expanded
      context.parent.chat = !context.parent.chat
    }

    function sendMessage() {
      let text = chatMessage.value
      chatMessage.value = ''
      let len = text.length
      if (len > 16384) {
        text = text.substr(0, 16384)
        text += "...( + ' + (len-16384) + ' chars)"
      }

      let eventHandlers = {
        'succeeded': E => null,
        'failed': E => null
      }

      let options = {
        'eventHandlers': eventHandlers
      }

      if (selectedChat.value != "public") {
        options.extraHeaders = ['Vibe-Privatechat: ' + selectedChat.value]
      }

      let destination
      if (context.root.$route.query.meetingID) {
        if (context.root.$route.query.pin) {
          destination = (context.root.$route.query.meetingID + context.root.$route.query.pin)
        } else {
          destination = context.root.$route.query.meetingID
        }
      } else if (context.parent.$parent.meetingData.meetingID) {
        if (context.parent.$parent.meetingData.pin) {
          destination = (context.parent.$parent.meetingData.meetingID + context.parent.$parent.meetingData.pin)
        } else {
          destination = context.parent.$parent.meetingData.meetingID
        }
      } else {
        return
      }

      if (selectedChat.value != null)
        context.parent.$parent.webrtcPhone.sendMessage(destination, text, options)
    }

    function processMessage(message) {
      let dateObject = new Date(message.timestamp)
      message.time = dateObject.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      });
      chats.value.push(message);
      if (!context.parent.chat) {
        context.parent.$parent.newChat = context.parent.$parent.newChat + 1
        beep()
      }
      setTimeout(function () {
        context.refs.chatArea.$el.scrollTop = context.refs.chatArea.$el.scrollHeight
      }, 100)
    }

    function pressedEnter(e) {
      if (e.keyCode === 13) {
        sendMessage()
      }
    }

    const isDisabledChat = computed(() => {
      if (selectedChat.value == null) {
        return true
      } else {
        if (context.parent.$parent.$refs.meetingControls.meetingOptions.includes('ch=16') || context.parent.$parent.$refs.meetingControls.meetingOptions.includes('ch=20')) {
          return true
        } else {
          return false
        }
      }
    })

    return {
      dateLastUpdate,
      chatMessage,
      sendMessage,
      pressedEnter,
      publicChat,
      selectedChat,
      isDisabledChat,
      chats,
      processMessage,
      toggleChat,
    }
  }
}
</script>
<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>




// WEBPACK FOOTER //
// src/components/ChatSideBar.vue